export const ACCESS_TOKEN = "access_token";
export const ACCESS_TICKET = "access_ticket";
export const USER_TYPE = "user_type";